import { formatNumber } from '@util/formatNumber';

export const formatStatistics = (statBlockProps, data) => {
  return Object.keys(data)
    .filter((dt) =>
      statBlockProps.find(
        (sb) => dt.toLocaleLowerCase() === sb.replace(/\s/g, '').toLocaleLowerCase(),
      ),
    )
    .map((dt) => {
      let title;
      if (dt === 'noOfAdvisorsWorldwide') {
        title = 'noOfAdvisorsGlobally';
      } else if (dt === 'noOfAdvisorsAmericas') {
        title = 'noOfAmericasAdvisors';
      } else if (dt === 'noOfCountriesEngelVolkersIsIn') {
        title = 'noOfCountries';
      } else {
        title = dt;
      }
      title = title.replace('noOf', '').replace(/\B([A-Z])\B/g, ' $1');
      return {
        title,
        count: formatNumber(data[dt]),
      };
    });
};
